<template>

    <div class="menu-bar">
        <transition name="slide-up">
            <div class="menu-wrapper"  v-show="menushow"  :class="{'hide-box-shadow':issettingshow||!menushow}">
                <div class="icon-wrapper">
                    <span class="iconfont icon-menu"  @click="showsetting(3)"></span>
                    <span class="iconfont icon-progress" @click="showsetting(2)"></span>
                    <span class="iconfont icon-bright" @click="showsetting(1)"></span>
                    <span class="iconfont icon-A" @click="showsetting(0)">
                    A
                </span>
                </div>
            </div>
        </transition>
        <transition name="slide-up">
            <div class="setting-wrapper" v-show="issettingshow">
                <div v-if="showtag===0" class="setting-font-size">

                    <div class="preview" :style="{fontSize:fontsizelist[0].fontSize+'px'}">A</div>
                    <div class="select">
                        <div class="select-wrappers"  v-for="(item,index) in fontsizelist" :key="index" @click="setfontsizefun(item.fontSize)">
                            <div class="line"></div>
                            <div class="point-wrapper">
                                <div class="point" v-show="defaultfontsize==item.fontSize">
                                    <div class="small-point"></div>
                                </div>

                            </div>
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="preview" :style="{fontSize:fontsizelist[fontsizelist.length-1].fontSize+'px'}">A</div>
                </div>
                <div class="setting-theme"  v-if="showtag===1">
                    <div class="setting-theme-item" v-for="(item,index) in themelist" :key="index"  @click="setthemes(index)">
                        <div class="preview" :style="{background:item.style.body.background}" :class="{'no-border':item.style.body.background!=='#fff'}"></div>
                        <div class="text" :class="{'selected': index === defaulttheme}">{{item.name}}</div>
                    </div>
                </div>
                <div class="setting-progress" v-else-if="showtag===2" >
                    <div class="progress-wrapper">
                        <input class="progress"
                               type="range"
                               max="100"
                               min="0"
                               step="1"
                               @change="onprogresschange($event.target.value)"
                               @input="onprogressinput($event.target.value)"
                               :value="progress"
                               :disabled="!bookavailable"
                               ref="progress"
                        >
                        <div class="text-wrapper">
                            <span>{{bookavailable ? progress+'%':'加载中...'}}</span>
                        </div>
                    </div>

                </div>

            </div>
        </transition>
        <contentview

                :isshowconten="isshowconten"
                v-show="isshowconten"
                :navigation="navigation"
                :bookavailable="bookavailable"
                @jumpto="jumpto"


        ></contentview>
        <transition name="fade">
            <div class="content-mask" v-show="isshowconten" @click="hidecontent">

            </div>
        </transition>
    </div>

</template>

<script>
    import contentview from  "./contentview"
    export default {
        props:["menushow","fontsizelist","defaultfontsize","themelist","defaulttheme","bookavailable",'navigation'],
        name: "ebookmenu",
        components:{
            contentview
        },
        data() {
            return {
                issettingshow:false,
                // issetfontsize:false,
                showtag:0,
                progress:0,
                isshowconten:false,
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            jumpto(target){
                this.$emit('jumpto',target)
            },
            onprogresschange(progress){
                this.$emit('onprogresschange',progress)
            },
            onprogressinput(progress){
                this.progress=progress
                this.$refs.progress.style.backgroundSize=`${this.progress}% 100%`
            },
            setthemes(index){
                this.$emit('settheme',index)
            },
            setfontsizefun(fonsize){
                this.$emit('setfontsizefun',fonsize)
            },
            // isshowsetfontsize(){
            //     this.issetfontsize=!this.issetfontsize
            //     if(this.issetfontsize){
            //         this.showsetting()
            //     }else{
            //         this.hidesetfontsize()
            //     }
            // },
            showsetting(tag){

                this.showtag=tag
                if(this.showtag===3){
                    this.issettingshow=false;
                    this.isshowconten=true

                }else{
                    this.issettingshow=true
                }

            },
            hidesetfontsize(){
                this.issettingshow=false
            },
            hidecontent(){
                this.isshowconten=false
            },
            // backbefore(){
            //     // alert(1)
            //     //   SmartCity.goBack();
            //     this.$emit('callback', 'left')
            // },
            // share(){
            //     this.$emit('callback', 'right')
            //     // SmartCity.shareTo(this.ztopData.sharedata);
            // }
        },
    }

</script>

<style scoped lang="scss">
    @import '../assets/styles/global.scss';
    .menu-bar{
        .menu-wrapper{
            position: absolute;
            bottom:0;
            left:0;
            display: flex;
            width: 100%;
            height: px2rem(48);
            z-index: 101;
            background: white;
            box-shadow: 0 px2rem(-8) px2rem(8) rgba(0,0,0,.15) ;
            &.hide-box-shadow{
                box-shadow:none;
            }
            .icon-wrapper{
                flex: 0 0 100%;
                @include center;

                span{
                    text-align: center;
                    width: 25%;
                    /*padding: 0 px2rem(20);*/
                }
            }

        }
        .setting-wrapper{
            position: absolute;
            bottom:px2rem(48);
            left:0;
            width: 100%;
            height: px2rem(60);
            background: white;
            z-index: 101;
            box-shadow: 0 px2rem(-8)  px2rem(8) rgba(0,0,0,.15);
            .setting-font-size{
                display: flex;
                height: 100%;
                /*width: 100%;*/
                .preview{
                    flex: 0 0 px2rem(40);
                    @include center;
                    /*background: orange;*/
                }
                .select{
                    display: flex;
                    flex: 1;
                    .select-wrappers{
                        flex:1;
                        display: flex;
                        align-items: center;
                        /*background: yellow;*/
                        &:first-child{
                            .line{
                                &:first-child{
                                    border-top:none;
                                }
                            }

                        }
                        &:last-child{
                            .line{
                                &:last-child{
                                    border-top:none;
                                }
                            }

                        }
                        .line{
                            flex:1;
                            height: 0;
                            border-top:px2rem(1) solid #ccc;
                        }
                        .point-wrapper{
                            position: relative;
                            flex: 0 0 0;
                            width:0;
                            height: px2rem(7);
                            border-left:px2rem(1) solid #ccc;
                            .point{
                                position: absolute;
                                top:px2rem(-8);
                                left:px2rem(-10);
                                width: px2rem(20);
                                height:px2rem(20);
                                border-radius: 50%;
                                background: white;
                                border: px2rem(1) solid #ccc;
                                box-shadow: 0 px2rem(4) px2rem(4) rgba(0,0,0,.15);
                                @include center;
                                .small-point{
                                    background: black;
                                    border-radius: 50%;
                                    width: px2rem(5);
                                    height:px2rem(5);
                                }
                            }


                        }


                    }
                }

            }
            .setting-theme{
                height:100%;
                display: flex;
                .setting-theme-item{
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    padding: px2rem(5);
                    box-sizing: border-box;
                }
                .preview{
                    flex:1;
                    border: px2rem(1) solid #ccc;
                    box-sizing: border-box;
                    &.no-border{
                        border: none;
                    }

                }

                .text{
                    flex: 0 0 px2rem(20);
                    font-size: px2rem(14);
                    color: #ccc;
                    @include center;
                    &.selected{
                        color: #333;
                    }
                }


            }
            .setting-progress{
                position: relative;
                width: 100%;
                height: 100%;
                .progress-wrapper{
                    width: 100%;
                    height: 100%;
                    @include center;
                    padding: 0 px2rem(30);
                    box-sizing: border-box;
                    .progress{
                        width: 100%;
                        -webkit-appearance: none;
                        height: px2rem(2);
                        background: -webkit-linear-gradient(#999,#999) no-repeat,#ddd;
                        background-size: 0 100%;
                        &:focus{
                            outline: none;

                        }
                        &::-webkit-slider-thumb{
                            -webkit-appearance: none;
                            height:px2rem(20);
                            width: px2rem(20);
                            border-radius: 50%;
                            background: white;
                            box-shadow: 0 4px 4px 0 rgba(0,0,0,.15);
                            border: px2rem(1) solid #ddd;
                        }
                    }
                    .text-wrapper{

                        /*flex: 0 0 px2rem(20);*/
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        color: #333;
                        font-size: px2rem(14);
                        text-align: center;
                    }

                }
            }
        }
        .content-mask{
            position: absolute;
            top:0;
            left:0;
            z-index: 101;
            display: flex;
            width: 100%;
            height: 100%;
            background: rgba(51,51,51,.8);

        }
    }

</style>


// WEBPACK FOOTER //
// src/components/ebookmenupc.vue